import { render, staticRenderFns } from "./VFiledrop.vue?vue&type=template&id=4884fd4c&scoped=true"
import script from "./VFiledrop.vue?vue&type=script&lang=js"
export * from "./VFiledrop.vue?vue&type=script&lang=js"
import style0 from "./VFiledrop.vue?vue&type=style&index=0&id=4884fd4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884fd4c",
  null
  
)

export default component.exports